module.exports = __webpack_public_path__ + "media/images/pages/peel/concept-c4349934c3eea8f76ea2cba47732d000.png";